import React, { useEffect, useState } from "react";
import CustomRichTable from "../common/DashBoardCustomRichTable";
import axios from 'axios';
const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
  return `${process.env.REACT_APP_API_SECURITY_KEY}`;
};
const bgColorMapping = {
  Pending: "#FDE8E4",
  Completed: "#DAF4F0",
  Process: "#FEF4E4"
};
const textColorMapping = {
  Pending: "#F05648",
  Completed: "#0AB39C",
  Process: "#F78848"
};
const columns = [
    
    { Header: 'Checkin ID', accessor: 'checkinId' },
    //{ Header: 'Customer', accessor: 'customerName' },
    { Header: 'Component', accessor: 'componentName' },
    { Header: 'Executive', accessor: 'fieldOfficerName' },
    { Header: 'Client', accessor: 'subClientName' },
    { Header: 'Date', accessor: 'createdDate' },
    {
      Header: 'Status',
      Cell: ({ row }) => (
        <p class={`px-2 py-1 w-fit rounded-md text-[9.75px] leading-[9.26px] font-semibold text-[#495057] 
                  text-[${textColorMapping[row.status]}] bg-[${bgColorMapping[row.status]}]`}>
          {row.status}
        </p>
      ),
    },
    //{ Header: 'Status', accessor: 'status' },
    { Header: 'TAT', accessor: 'tat' },
  ];
export function Orders() {
  const [tasks, setTasks] = useState([]);
  useEffect(() => {
    const fetchfiles = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/client/dash/getprocessingcomponentsbyorganization/${localStorage.getItem('clientID')}`,
        //const response = await axios.get(`${API_BASE_URL}/client/office/getsubmittedfilesbyorganization/${localStorage.getItem('clientID')}`,
        {
            headers: {
              'auth_key': `${getAuthKey()}`,
            }
          }
        );
        const resultData = response.data.result;
        const updatedData = resultData.map(item => {
          let status = '';
          switch(item.status) {
            case 0:
              status = 'Pending';
              break;
            case 1:
             status = 'Process';
              break;
            case 2:
              status = 'Completed';
              break;
            default:
              status = '---';
          }
          return {
            ...item,
            status
          };
        });
        setTasks(updatedData);
      } catch (err) {
        console.log('Failed to fetchfiles');
      } finally {
        //setLoading(false);
        //setIsProcessing(false);
      }
    };
    fetchfiles();
  }, []);
  return (
    <div className="relative w-full overflow-x-auto">
      {/* <table className="w-full caption-bottom">
        <thead className="border-b">
          <tr className="bg-[#F3F6F9] text-[13px] font-semibold leading-[19.5px] h-[44px]">
            {headers.map((header) => (
              <th key={header} className={`truncate h-12 p-[10px] ${header === "Amount" ? 'text-right' : 'text-left'} align-middle font-medium text-neutral-500 dark:text-neutral-400`}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.map((items, index) => (
            <tr
              key={items.id}
              className="transition-colors hover:bg-neutral-100/50"
            >
              <td className="pl-2 align-middle text-[13px] font-medium leading-[19.5px] text-[#33416E]">{index+1}</td>
              <td className="py-[12px] px-1 align-middle truncate flex items-center gap-2 text-[13px] leading-[19.5px] text-[#212529] w-[140px]">
                
                {items.customer}
              </td>
              <td className="align-middle truncate text-[13px] leading-[19.5px] text-[#212529]">{items.product}</td>
              <td className="align-middle text-center text-[13px] leading-[19.5px] text-[#0AB39C]">{items.totalAmount}</td>
              <td className="align-middle truncate text-[13px] leading-[19.5px] text-[#212529]">{items.vendor}</td>
              <td style={{textAlign: '-webkit-center'}}>
                <p
                  className={`px-2 py-1 w-fit rounded-md text-[9.75px] leading-[9.26px] font-semibold text-[#495057] 
                  ${items.status === "Pending"
                      ? "text-[#F78848] bg-[#FEF4E4]"
                      : items.status === "Unpaid"
                        ? "text-[#F05648] bg-[#FDE8E4]"
                        : "text-[#0AB39C] bg-[#DAF4F0]"
                    }`}
                >
                  {items.status}
                </p>
              </td>
              <td className="p-2 align-middle truncate text-[9.75px] leading-[9.26px] font-semibold text-[#495057]">
                {items.rating}{" "}
                <span className="text-[11px] leading-[13.2px] font-medium text-[#878A99]">({items.votes} votes)</span>
              </td>
            </tr>
          ))}
        </tbody>

      </table>
      <div className="flex justify-between p-4 border-t bottom-0">
        <p className='text-[13px] text-[#878A99]'>Showing 5 of 25 Results</p>
        <div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          /></div>
      </div> */}
      <CustomRichTable columns={columns} data={tasks}/>
    </div>
  );
}

